//digitalFingerprint.min.js is required to be referenced in the page that calls the following function
export function getFingerprint() {
    if (sessionStorage.getItem('deviceFingerprint')) {
        return sessionStorage.getItem('deviceFingerprint');
    }
    var fingerprint = JSON.stringify(secureAuth.fingerprint.getAllResults());
    sessionStorage.setItem('deviceFingerprint', fingerprint);
    return fingerprint;
}